import { getUserFromStorage } from '@/configuration';

export function getUserId() {
	const user = getUserFromStorage();
	return user ? user.memberId : null;
}
